import { location, onMount, reactive } from 'cdui-js';
import i18n from '../../../i18n';
import { DiFiInput } from '../../../components/DiFi/DiFiInput';
import { showToast } from '../components/Toast';
import { goBackByBrowser, routeReplace } from '../../../lib/browser';
import { StiFormField } from './FormField';
import { StockTransferNav } from './Nav';
import {
  getOtherOutBrokerDraft,
  getSelectedOutBroker,
  readBrokerIdQuery,
  readMarketQuery,
  setOtherOutBrokerDraft,
  syncStockTransferAppShell,
  withStockTransferQuery,
  type StockTransferMarket,
} from './shared';
import './page.css';

export const StockTransferInOtherBroker = () => {
  const state = reactive({
    market: 'HK' as StockTransferMarket,
    brokerId: 0,
    customName: '',
  });

  const onNext = () => {
    if (!state.customName.trim()) {
      showToast(i18n.StockTransferIn.PleaseInputOutParty);
      return;
    }
    setOtherOutBrokerDraft({ customName: state.customName });
    location.routeTo(
      withStockTransferQuery('/h5/stock-transfer-in/broker', {
        market: state.market,
        brokerId: String(state.brokerId),
      }),
      [0, 0],
    );
  };

  const onClose = () => {
    routeReplace(withStockTransferQuery('/h5/stock-transfer-in'));
  };

  onMount(() => {
    syncStockTransferAppShell();
    state.market = readMarketQuery();
    state.brokerId = readBrokerIdQuery();
    const selected = getSelectedOutBroker();
    if (!state.brokerId || selected?.isOther !== 1) {
      location.routeTo(withStockTransferQuery('/h5/stock-transfer-in/select-broker', { market: state.market }), [0, 0]);
      return;
    }
    const draft = getOtherOutBrokerDraft();
    if (draft) state.customName = draft.customName;
  });

  return (
    <div class="stock-transfer-in-h5">
      <StockTransferNav title={i18n.StockTransferIn.FillOtherBrokerTitle} onBack={goBackByBrowser} onClose={onClose} />
      <div class="sti-scroll">
        <div class="sti-form">
          <StiFormField label={i18n.StockTransferIn.LabelOutParty}>
            <DiFiInput
              shellClass="f-input-2"
              inputKind="text"
              maxLength={100}
              placeholder={i18n.StockTransferIn.OutPartyPlaceholder}
              value={state.customName}
              onUpdateValue={(v) => {
                state.customName = v;
              }}
            />
          </StiFormField>
        </div>
      </div>
      <div class="sti-footer">
        <button type="button" class="primary-btn btn-rounded width-100" onclick={onNext}>
          {i18n.StockTransferIn.NextStep}
        </button>
      </div>
    </div>
  );
};
